<template>
  <div>
    <v-flex xs12>
      <p class="mt-4" ref="title">
        <b>{{ label }}</b>
      </p>
      <div>
        <v-tabs slider-color="primary" v-model="activeTab">
          <v-tab :key="0">{{ $t('common.Search') }}</v-tab>
          <v-tab :key="1">{{ $tc('common.Tree') }}</v-tab>
          <v-tab-item>
            <v-autocomplete
              :value="value"
              @change="updateItems"
              :return-object="false"
              :multiple="true"
              dont-fill-mask-blanks
              :filter="baseStringSearch"
              hide-no-data
              hide-selected
              :items="drugList"
              :label="$t('common.Search')"
              item-text="label"
              item-value="id"
              chips
              deletable-chips
              dense
              clearable
              :menu-props="{
                closeOnClick: false,
                closeOnContentClick: false,
                openOnClick: false,
                maxHeight: $vuetify.breakpoint.smAndDown ? 170 : 300,
              }"
            />
          </v-tab-item>
          <v-tab-item>
          <v-treeview :items="drugTree" item-text="label" :open="treeOpen" dense>
            <template v-slot:prepend="{item}">
              <v-icon
                v-if="item.groupId && value.includes(item.id)"
                @click="selectItem(item.id)"
              >check_box</v-icon>
              <v-icon
                v-else-if="item.groupId"
                @click="selectItem(item.id)"
              >check_box_outline_blank</v-icon>
            </template>
            <template v-slot:label="{item}">
              <span @click="item.groupId ? selectItem(item.id) : null">{{ item.label }}</span>
            </template>
          </v-treeview>
        </v-tab-item>
        </v-tabs>
      </div>
    </v-flex>
  </div>
</template>

<script>
import baseStringSearch from '@/utils/baseStringSearch'
import { DrugClass, DrugTree } from '@/models/Drugs'
export default {
  props: {
    value: { type: Array, default: ()=>([])},
    label: { type: String, default: '' },
  },
  data: () => ({
    activeTab: '0',
    treeOpen: [],
  }),
  computed: {
    drugList(){
      return DrugClass.all()
    },
    drugTree(){
      return DrugTree.find('main').tree
    }
  },
  methods: {
    baseStringSearch,
    selectItem(itemId){
      const items = [...this.value]
      if(items.includes(itemId)){
        items.splice(items.indexOf(itemId), 1)
      } else {
        items.push(itemId)
      }
      this.$emit('input', items)
    },
    updateItems(items){
      this.$emit('input', items)
    }
  }
}
</script>

<style>
</style>